export default {
  'disablements': 'Incapacités',
  'search.customers': 'Rechercher des clients',
  'search.results': 'Résultats de Recherche',
  'towingNeeded': 'Remorquage Nécessaire',
  'towingNotNeeded': 'Remorquage Non Nécessaire',
};